function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/**
 * @packageDocumentation
 * @module Voice
 * @preferred
 * @publicapi
 */


import { EventEmitter } from 'events';
import Call from '../call';
import Device from '../device';
import { GeneralErrors, NotSupportedError, SignalingErrors } from '../errors';
import Log from '../log';
import { getRTCIceCandidateStatsReport } from '../rtc/stats';
import { COWBELL_AUDIO_URL, ECHO_TEST_DURATION } from '../constants';
/**
 * Runs some tests to identify issues, if any, prohibiting successful calling.
 */

export var PreflightTest = /*#__PURE__*/function (_EventEmitter) {
  _inherits(PreflightTest, _EventEmitter);

  var _super = _createSuper(PreflightTest);

  /**
   * Construct a {@link PreflightTest} instance.
   * @constructor
   * @param token - A Twilio JWT token string.
   * @param options
   */
  function PreflightTest(token, options) {
    var _this;

    _classCallCheck(this, PreflightTest);

    _this = _super.call(this);
    /**
     * Whether this test has already logged an insights-connection-warning.
     */

    _this._hasInsightsErrored = false;
    /**
     * An instance of Logger to use.
     */

    _this._log = new Log('PreflightTest');
    /**
     * Network related timing measurements for this test
     */

    _this._networkTiming = {};
    /**
     * The options passed to {@link PreflightTest} constructor
     */

    _this._options = {
      codecPreferences: [Call.Codec.PCMU, Call.Codec.Opus],
      edge: 'roaming',
      fakeMicInput: false,
      logLevel: 'error',
      signalingTimeoutMs: 10000
    };
    /**
     * Current status of this test
     */

    _this._status = PreflightTest.Status.Connecting;
    Object.assign(_this._options, options);
    _this._samples = [];
    _this._warnings = [];
    _this._startTime = Date.now();

    _this._initDevice(token, Object.assign(Object.assign({}, _this._options), {
      fileInputStream: _this._options.fakeMicInput ? _this._getStreamFromFile() : undefined
    })); // Device sets the loglevel so start logging after initializing the device.
    // Then selectively log options that users can modify.


    var userOptions = ['codecPreferences', 'edge', 'fakeMicInput', 'logLevel', 'signalingTimeoutMs'];
    var userOptionOverrides = ['audioContext', 'deviceFactory', 'fileInputStream', 'getRTCIceCandidateStatsReport', 'iceServers', 'rtcConfiguration'];

    if (_typeof(options) === 'object') {
      var toLog = Object.assign({}, options);
      Object.keys(toLog).forEach(function (key) {
        if (!userOptions.includes(key) && !userOptionOverrides.includes(key)) {
          delete toLog[key];
        }

        if (userOptionOverrides.includes(key)) {
          toLog[key] = true;
        }
      });

      _this._log.debug('.constructor', JSON.stringify(toLog));
    }

    return _this;
  }
  /**
   * Stops the current test and raises a failed event.
   */


  _createClass(PreflightTest, [{
    key: "stop",
    value: function stop() {
      var _this2 = this;

      this._log.debug('.stop');

      var error = new GeneralErrors.CallCancelledError();

      if (this._device) {
        this._device.once(Device.EventName.Unregistered, function () {
          return _this2._onFailed(error);
        });

        this._device.destroy();
      } else {
        this._onFailed(error);
      }
    }
    /**
     * Emit a {PreflightTest.Warning}
     */

  }, {
    key: "_emitWarning",
    value: function _emitWarning(name, description, rtcWarning) {
      var warning = {
        name: name,
        description: description
      };

      if (rtcWarning) {
        warning.rtcWarning = rtcWarning;
      }

      this._warnings.push(warning);

      this._log.debug("#".concat(PreflightTest.Events.Warning), JSON.stringify(warning));

      this.emit(PreflightTest.Events.Warning, warning);
    }
    /**
     * Returns call quality base on the RTC Stats
     */

  }, {
    key: "_getCallQuality",
    value: function _getCallQuality(mos) {
      if (mos > 4.2) {
        return PreflightTest.CallQuality.Excellent;
      } else if (mos >= 4.1 && mos <= 4.2) {
        return PreflightTest.CallQuality.Great;
      } else if (mos >= 3.7 && mos <= 4) {
        return PreflightTest.CallQuality.Good;
      } else if (mos >= 3.1 && mos <= 3.6) {
        return PreflightTest.CallQuality.Fair;
      } else {
        return PreflightTest.CallQuality.Degraded;
      }
    }
    /**
     * Returns the report for this test.
     */

  }, {
    key: "_getReport",
    value: function _getReport() {
      var stats = this._getRTCStats();

      var testTiming = {
        start: this._startTime
      };

      if (this._endTime) {
        testTiming.end = this._endTime;
        testTiming.duration = this._endTime - this._startTime;
      }

      var report = {
        callSid: this._callSid,
        edge: this._edge,
        iceCandidateStats: this._rtcIceCandidateStatsReport.iceCandidateStats,
        networkTiming: this._networkTiming,
        samples: this._samples,
        selectedEdge: this._options.edge,
        stats: stats,
        testTiming: testTiming,
        totals: this._getRTCSampleTotals(),
        warnings: this._warnings
      };
      var selectedIceCandidatePairStats = this._rtcIceCandidateStatsReport.selectedIceCandidatePairStats;

      if (selectedIceCandidatePairStats) {
        report.selectedIceCandidatePairStats = selectedIceCandidatePairStats;
        report.isTurnRequired = selectedIceCandidatePairStats.localCandidate.candidateType === 'relay' || selectedIceCandidatePairStats.remoteCandidate.candidateType === 'relay';
      }

      if (stats) {
        report.callQuality = this._getCallQuality(stats.mos.average);
      }

      return report;
    }
    /**
     * Returns RTC stats totals for this test
     */

  }, {
    key: "_getRTCSampleTotals",
    value: function _getRTCSampleTotals() {
      if (!this._latestSample) {
        return;
      }

      return Object.assign({}, this._latestSample.totals);
    }
    /**
     * Returns RTC related stats captured during the test call
     */

  }, {
    key: "_getRTCStats",
    value: function _getRTCStats() {
      var firstMosSampleIdx = this._samples.findIndex(function (sample) {
        return typeof sample.mos === 'number' && sample.mos > 0;
      });

      var samples = firstMosSampleIdx >= 0 ? this._samples.slice(firstMosSampleIdx) : [];

      if (!samples || !samples.length) {
        return;
      }

      return ['jitter', 'mos', 'rtt'].reduce(function (statObj, stat) {
        var values = samples.map(function (s) {
          return s[stat];
        });
        return Object.assign(Object.assign({}, statObj), _defineProperty({}, stat, {
          average: Number((values.reduce(function (total, value) {
            return total + value;
          }) / values.length).toPrecision(5)),
          max: Math.max.apply(Math, _toConsumableArray(values)),
          min: Math.min.apply(Math, _toConsumableArray(values))
        }));
      }, {});
    }
    /**
     * Returns a MediaStream from a media file
     */

  }, {
    key: "_getStreamFromFile",
    value: function _getStreamFromFile() {
      var audioContext = this._options.audioContext;

      if (!audioContext) {
        throw new NotSupportedError('Cannot fake input audio stream: AudioContext is not supported by this browser.');
      }

      var audioEl = new Audio(COWBELL_AUDIO_URL);
      audioEl.addEventListener('canplaythrough', function () {
        return audioEl.play();
      });

      if (typeof audioEl.setAttribute === 'function') {
        audioEl.setAttribute('crossorigin', 'anonymous');
      }

      var src = audioContext.createMediaElementSource(audioEl);
      var dest = audioContext.createMediaStreamDestination();
      src.connect(dest);
      return dest.stream;
    }
    /**
     * Initialize the device
     */

  }, {
    key: "_initDevice",
    value: function _initDevice(token, options) {
      var _this3 = this;

      try {
        this._device = new (options.deviceFactory || Device)(token, {
          codecPreferences: options.codecPreferences,
          edge: options.edge,
          fileInputStream: options.fileInputStream,
          logLevel: options.logLevel,
          preflight: true
        });

        this._device.once(Device.EventName.Registered, function () {
          _this3._onDeviceRegistered();
        });

        this._device.once(Device.EventName.Error, function (error) {
          _this3._onDeviceError(error);
        });

        this._device.register();
      } catch (error) {
        // We want to return before failing so the consumer can capture the event
        setTimeout(function () {
          _this3._onFailed(error);
        });
        return;
      }

      this._signalingTimeoutTimer = setTimeout(function () {
        _this3._onDeviceError(new SignalingErrors.ConnectionError('WebSocket Connection Timeout'));
      }, options.signalingTimeoutMs);
    }
    /**
     * Called on {@link Device} error event
     * @param error
     */

  }, {
    key: "_onDeviceError",
    value: function _onDeviceError(error) {
      this._device.destroy();

      this._onFailed(error);
    }
    /**
     * Called on {@link Device} ready event
     */

  }, {
    key: "_onDeviceRegistered",
    value: function _onDeviceRegistered() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this4 = this;

        var audio, publisher;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                clearTimeout(this._echoTimer);
                clearTimeout(this._signalingTimeoutTimer);
                _context.next = 4;
                return this._device.connect({
                  rtcConfiguration: this._options.rtcConfiguration
                });

              case 4:
                this._call = _context.sent;
                this._networkTiming.signaling = {
                  start: Date.now()
                };

                this._setupCallHandlers(this._call);

                this._edge = this._device.edge || undefined;

                if (this._options.fakeMicInput) {
                  this._echoTimer = setTimeout(function () {
                    return _this4._device.disconnectAll();
                  }, ECHO_TEST_DURATION);
                  audio = this._device.audio;

                  if (audio) {
                    audio.disconnect(false);
                    audio.outgoing(false);
                  }
                }

                this._call.once('disconnect', function () {
                  _this4._device.once(Device.EventName.Unregistered, function () {
                    return _this4._onUnregistered();
                  });

                  _this4._device.destroy();
                });

                publisher = this._call['_publisher'];
                publisher.on('error', function () {
                  if (!_this4._hasInsightsErrored) {
                    _this4._emitWarning('insights-connection-error', 'Received an error when attempting to connect to Insights gateway');
                  }

                  _this4._hasInsightsErrored = true;
                });

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Called when there is a fatal error
     * @param error
     */

  }, {
    key: "_onFailed",
    value: function _onFailed(error) {
      clearTimeout(this._echoTimer);
      clearTimeout(this._signalingTimeoutTimer);

      this._releaseHandlers();

      this._endTime = Date.now();
      this._status = PreflightTest.Status.Failed;

      this._log.debug("#".concat(PreflightTest.Events.Failed), error);

      this.emit(PreflightTest.Events.Failed, error);
    }
    /**
     * Called when the device goes offline.
     * This indicates that the test has been completed, but we won't know if it failed or not.
     * The onError event will be the indicator whether the test failed.
     */

  }, {
    key: "_onUnregistered",
    value: function _onUnregistered() {
      var _this5 = this;

      // We need to make sure we always execute preflight.on('completed') last
      // as client SDK sometimes emits 'offline' event before emitting fatal errors.
      setTimeout(function () {
        if (_this5._status === PreflightTest.Status.Failed) {
          return;
        }

        clearTimeout(_this5._echoTimer);
        clearTimeout(_this5._signalingTimeoutTimer);

        _this5._releaseHandlers();

        _this5._endTime = Date.now();
        _this5._status = PreflightTest.Status.Completed;
        _this5._report = _this5._getReport();

        _this5._log.debug("#".concat(PreflightTest.Events.Completed), JSON.stringify(_this5._report));

        _this5.emit(PreflightTest.Events.Completed, _this5._report);
      }, 10);
    }
    /**
     * Clean up all handlers for device and call
     */

  }, {
    key: "_releaseHandlers",
    value: function _releaseHandlers() {
      [this._device, this._call].forEach(function (emitter) {
        if (emitter) {
          emitter.eventNames().forEach(function (name) {
            return emitter.removeAllListeners(name);
          });
        }
      });
    }
    /**
     * Setup the event handlers for the {@link Call} of the test call
     * @param call
     */

  }, {
    key: "_setupCallHandlers",
    value: function _setupCallHandlers(call) {
      var _this6 = this;

      if (this._options.fakeMicInput) {
        // When volume events start emitting, it means all audio outputs have been created.
        // Let's mute them if we're using fake mic input.
        call.once('volume', function () {
          call['_mediaHandler'].outputs.forEach(function (output) {
            return output.audio.muted = true;
          });
        });
      }

      call.on('warning', function (name, data) {
        _this6._emitWarning(name, 'Received an RTCWarning. See .rtcWarning for the RTCWarning', data);
      });
      call.once('accept', function () {
        _this6._callSid = call['_mediaHandler'].callSid;
        _this6._status = PreflightTest.Status.Connected;

        _this6._log.debug("#".concat(PreflightTest.Events.Connected));

        _this6.emit(PreflightTest.Events.Connected);
      });
      call.on('sample', function (sample) {
        return __awaiter(_this6, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (this._latestSample) {
                    _context2.next = 4;
                    break;
                  }

                  _context2.next = 3;
                  return (this._options.getRTCIceCandidateStatsReport || getRTCIceCandidateStatsReport)(call['_mediaHandler'].version.pc);

                case 3:
                  this._rtcIceCandidateStatsReport = _context2.sent;

                case 4:
                  this._latestSample = sample;

                  this._samples.push(sample);

                  this._log.debug("#".concat(PreflightTest.Events.Sample), JSON.stringify(sample));

                  this.emit(PreflightTest.Events.Sample, sample);

                case 8:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));
      }); // TODO: Update the following once the SDK supports emitting these events
      // Let's shim for now

      [{
        reportLabel: 'peerConnection',
        type: 'pcconnection'
      }, {
        reportLabel: 'ice',
        type: 'iceconnection'
      }, {
        reportLabel: 'dtls',
        type: 'dtlstransport'
      }, {
        reportLabel: 'signaling',
        type: 'signaling'
      }].forEach(function (_ref) {
        var type = _ref.type,
            reportLabel = _ref.reportLabel;
        var handlerName = "on".concat(type, "statechange");
        var originalHandler = call['_mediaHandler'][handlerName];

        call['_mediaHandler'][handlerName] = function (state) {
          var timing = _this6._networkTiming[reportLabel] = _this6._networkTiming[reportLabel] || {
            start: 0
          };

          if (state === 'connecting' || state === 'checking') {
            timing.start = Date.now();
          } else if ((state === 'connected' || state === 'stable') && !timing.duration) {
            timing.end = Date.now();
            timing.duration = timing.end - timing.start;
          }

          originalHandler(state);
        };
      });
    }
    /**
     * The callsid generated for the test call.
     */

  }, {
    key: "callSid",
    get: function get() {
      return this._callSid;
    }
    /**
     * A timestamp in milliseconds of when the test ended.
     */

  }, {
    key: "endTime",
    get: function get() {
      return this._endTime;
    }
    /**
     * The latest WebRTC sample collected.
     */

  }, {
    key: "latestSample",
    get: function get() {
      return this._latestSample;
    }
    /**
     * The report for this test.
     */

  }, {
    key: "report",
    get: function get() {
      return this._report;
    }
    /**
     * A timestamp in milliseconds of when the test started.
     */

  }, {
    key: "startTime",
    get: function get() {
      return this._startTime;
    }
    /**
     * The status of the test.
     */

  }, {
    key: "status",
    get: function get() {
      return this._status;
    }
  }]);

  return PreflightTest;
}(EventEmitter);

(function (PreflightTest) {
  /**
   * The quality of the call determined by different mos ranges.
   * Mos is calculated base on the WebRTC stats - rtt, jitter, and packet lost.
   */
  var CallQuality;

  (function (CallQuality) {
    /**
     * If the average mos is over 4.2.
     */
    CallQuality["Excellent"] = "excellent";
    /**
     * If the average mos is between 4.1 and 4.2 both inclusive.
     */

    CallQuality["Great"] = "great";
    /**
     * If the average mos is between 3.7 and 4.0 both inclusive.
     */

    CallQuality["Good"] = "good";
    /**
     * If the average mos is between 3.1 and 3.6 both inclusive.
     */

    CallQuality["Fair"] = "fair";
    /**
     * If the average mos is 3.0 or below.
     */

    CallQuality["Degraded"] = "degraded";
  })(CallQuality = PreflightTest.CallQuality || (PreflightTest.CallQuality = {}));
  /**
   * Possible events that a [[PreflightTest]] might emit.
   */


  var Events;

  (function (Events) {
    /**
     * See [[PreflightTest.completedEvent]]
     */
    Events["Completed"] = "completed";
    /**
     * See [[PreflightTest.connectedEvent]]
     */

    Events["Connected"] = "connected";
    /**
     * See [[PreflightTest.failedEvent]]
     */

    Events["Failed"] = "failed";
    /**
     * See [[PreflightTest.sampleEvent]]
     */

    Events["Sample"] = "sample";
    /**
     * See [[PreflightTest.warningEvent]]
     */

    Events["Warning"] = "warning";
  })(Events = PreflightTest.Events || (PreflightTest.Events = {}));
  /**
   * Possible status of the test.
   */


  var Status;

  (function (Status) {
    /**
     * Call to Twilio has initiated.
     */
    Status["Connecting"] = "connecting";
    /**
     * Call to Twilio has been established.
     */

    Status["Connected"] = "connected";
    /**
     * The connection to Twilio has been disconnected and the test call has completed.
     */

    Status["Completed"] = "completed";
    /**
     * The test has stopped and failed.
     */

    Status["Failed"] = "failed";
  })(Status = PreflightTest.Status || (PreflightTest.Status = {}));
})(PreflightTest || (PreflightTest = {}));